import { render, staticRenderFns } from "./ReportsGeneral.vue?vue&type=template&id=5e3c1157"
import script from "./ReportsGeneral.vue?vue&type=script&lang=js"
export * from "./ReportsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports